export { Caption1Strong } from './Caption1Strong';
export { caption1StrongClassNames } from './useCaption1StrongStyles.styles';
